import React from "react";
import { fetchUpcomingPayments } from "../../store/reducers/dashboardSlice/api";
import { gridColumns_UpcomingPayments } from "../../Utils/TableColumnDefs";
import CommonGrid from "../CommonGrid";
import useFetchTableData from "../../useFetchTableData";
const upcomingFilter = [
  { name: "Upcoming Amount", key: "Amount", type: "range" },
  { name: "Check Date", key: "Check Date", type: "date" },
  { name: "Check Date", key: "Check Date", type: "month" },
];

const UpcomingPaymentsTable = ({ className = "", footer = true, viewAllModal = true  }) => {
  const { data, status, retry } = useFetchTableData(
    fetchUpcomingPayments,
    "upcomingPayments"
  );

  return (
    <CommonGrid
      status={status}
      onRetry={retry}
      className={`upcoming-payments col-sm-6 ${className}`}
      title={"Upcoming Payments"}
      gridColumns={gridColumns_UpcomingPayments}
      footer={footer}
      viewAllModal = {viewAllModal}
      columnData={data}
      filterOption={upcomingFilter}
      tableTotal={["Amount"]}
    />
  );
};

export default UpcomingPaymentsTable;
